module.exports = __webpack_public_path__ + "img/touchback.28b2a212.jpg";